import { Timestamp } from '@griply/types';
import { getTimeLeftLabel } from '@griply/utils';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import { useToday } from 'shared/contexts/today';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';

import * as Styled from './time-left.style';

export type TimeLeftProps = {
  startIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  date: Timestamp;
  isShort?: boolean;
  isMidShort?: boolean;
  isSmallIcon?: boolean;
  noColor?: boolean;
};

export const TimeLeft: React.FC<TimeLeftProps> = ({
  date,
  startIcon,
  isShort,
  isMidShort,
  isSmallIcon,
  noColor,
}) => {
  const containerRef = useRef<HTMLSpanElement>(null);
  const today = useToday();
  const { t } = useTranslation();
  const language = useI18nLocale();

  const { label, isOverdue, isLastWeek } = getTimeLeftLabel(date, {
    today,
    t,
    language,
    short: isShort,
    midShort: isMidShort,
  });

  return (
    <Styled.Container
      ref={containerRef}
      $overdue={isOverdue}
      $lastWeek={isLastWeek}
      $noColor={!!noColor}
    >
      {!!startIcon && (
        <Styled.IconContainer $isSmall={!!isSmallIcon}>
          <Icon icon={startIcon} />
        </Styled.IconContainer>
      )}

      <Styled.Label>{label}</Styled.Label>
    </Styled.Container>
  );
};
